import '../App.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams  } from "react-router-dom";
import SwiperCore, { Navigation, Autoplay } from 'swiper';

import { ethers } from "ethers"
import { WagmiConfig, createClient, chain, useAccount, useSwitchNetwork } from "wagmi";
import { ConnectKitProvider, ConnectKitButton, getDefaultClient } from "connectkit";
import { alchemyProvider } from 'wagmi/providers/alchemy'

import axios from 'axios';

import { gold_allowed } from '../utils/goldVouchers.js';

import { CrossmintPayButton } from "@crossmint/client-sdk-react-ui";

function App() {

  /* global BigInt */

  const navigate = useNavigate();

  const [mintvalue, setMintValue] = useState('');
  const [voucher, setVoucher] = useState('');
  const [addr, setAddress] = useState('');

  const [mintvalueReserved, setMintValueReserved] = useState('');
  const [mode, setMode] = useState('');

  const alchemyId = 'uY4eHA9TUYaqCjKOmFT-4_SrEWz4cGEv';
   
  const chains = [chain.mainnet];

  const client = createClient(
      getDefaultClient({
          appName: "ROTA",
          alchemyId,
          chains,
      })
  );

  const loadConnect = () => {
    document.getElementById("connect-wallet").style.display="none"
    document.getElementById("rota-reserved-mint").style.display="none";
    document.getElementById("rota-public-mint").style.display=null;
  }

  const Connected = () => {

    useAccount({
        async onConnect({address}) {
          document.getElementById("mint-button").classList.add("disabled-events")
          document.getElementById("mint-button").innerHTML = "Loading Stats..."
          document.getElementById("mint-button").style.display=null;
          document.getElementById("mutation-calcs").style.display=null;
          setAddress(address)
          getStats(address)
          return
        },
        onDisconnect() {
          navigate('/');
          return
        },
    })
  }

const contract = {
    address: "0xDfB29501b42f63A947Ddc5249F185D6BcBE6986f",
    abi: [
      "function genesisMinted(uint16) external view returns (bool)"
    ]
};

const mutationGlass = {
  address: "0x775D576F54901B4bf23CB66B21dD14343c8AF888",
  abi: [
      "function balanceOf(address account, uint256 id) external view returns (uint256)",
  ]
};

const genesisContract = {
  address: "0x7CB90567a118cd9F6CA326067A0813b289bdCb54",
  abi: [
      "function balanceOf(address account) external view returns (uint256)",
      "function ownerOf(uint256 tokenId) public view override returns (address)",
      "function tokenOfOwnerByIndex(address owner, uint256 index) external view returns (uint256 tokenId)"
    ]
};

async function getStats(address) {

  const RPC = "https://eth-mainnet.g.alchemy.com/v2/uY4eHA9TUYaqCjKOmFT-4_SrEWz4cGEv";
  const provider = new ethers.providers.JsonRpcProvider(RPC);

  const CONTRACT_ADDRESS_MUTATION = new ethers.Contract(contract.address, contract.abi, provider);
  const CONTRACT_ADDRESS = new ethers.Contract(genesisContract.address, genesisContract.abi, provider);
  const MUTATION_ADDRESS = new ethers.Contract(mutationGlass.address, mutationGlass.abi, provider);

  var bal = await CONTRACT_ADDRESS.balanceOf(address);
  var bal1 = await MUTATION_ADDRESS.balanceOf(address,1);
  var bal2 = await MUTATION_ADDRESS.balanceOf(address,2);
  var bal69 = await MUTATION_ADDRESS.balanceOf(address,69);

  var totalBal = Number(BigInt(bal));
  var totalBal1 = Number(BigInt(bal1));
  var totalBal2 = Number(BigInt(bal2));
  var totalBal69 = Number(BigInt(bal69));

  document.getElementById("amount-of-reserve").innerHTML  = totalBal;

  var balanceOfTokensGlass = totalBal1 +  totalBal2 +  totalBal69;

  document.getElementById("amount-of-reserve-glass").innerHTML  = balanceOfTokensGlass;

  var oldBalance = bal;

  var i = 0;

  try{

  while(i<= bal){

    var indexToken = await CONTRACT_ADDRESS.tokenOfOwnerByIndex(address,i);
    var token = Number(BigInt(indexToken));
    var minted = await CONTRACT_ADDRESS_MUTATION.genesisMinted(token);

        if(minted){
          bal--
      }
      i++
  }
}
catch(e){
  oldBalance = bal
}

  document.getElementById("amount-of-mutations").innerHTML  = oldBalance - bal;
  document.getElementById("amount-of-mutations-left").innerHTML  = Math.min(bal, balanceOfTokensGlass);

  document.getElementById("mint-button").classList.remove("disabled-events")

  document.getElementById("mint-button").innerHTML = "Start Muation"

  if(Math.min(bal, balanceOfTokensGlass) === 0){
  document.getElementById("mint-button").innerHTML =  "Not Eligible"
  document.getElementById("mint-button").classList.add("disabled")
}

}

const COST_GOLD = 49000000000000000;
const COST_GOLD_ETH = 0.049;

class transaction {
  constructor(contractAddress, chainId, signer) {
      this.contractAddress = contractAddress;
      this.chainId = chainId;
      this.signer = signer;
  }

  static async allowlistGold() {

      const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();
      let userAddress = await signer.getAddress();

      const CONTRACT_ADDRESS = new ethers.Contract(contract.address, contract.abi, provider);

      var totalsupply = await CONTRACT_ADDRESS.totalSupply();

      const balance = await CONTRACT_ADDRESS.numMintedPerPersonGold(userAddress);
      const bal = parseInt(balance, 16);

      var minted = Number(balance)


      var ethAmount = String(BigInt(mintvalue * COST_GOLD));

      let overrides = {
          value: ethAmount
      };

      const connectedAddr = await signer.getAddress();

      const eth = await provider.getBalance(signer.getAddress());
      let ethbalance = parseInt(eth) / 1000000000000000000;


              if(voucher === undefined){
              document.getElementById("mint-button").innerHTML = "Not on Allowlist"
              document.getElementById("mint-button").classList.add("disabled")
              document.getElementById("mint-button").style.color="black";
              }
              else{
                  const hash = new ethers.Contract(contract.address, contract.abi, signer);
                  const tx = await hash.mintAllowlistGold(connectedAddr, voucher, mintvalue, false, overrides);
                  document.getElementById("mint-button-credit-card").style.display="none";
                  document.getElementById("mint-button").classList.add("disabled")
                  document.getElementById("starter-mint").innerHTML = "Minting..."
                  document.getElementById("minted-1").style.display="none"
                  document.getElementById("minted-2").style.display="none"
                  document.getElementById("select").classList.add("disabled")
                  document.getElementById("mint-button").style.color="black";
                  document.getElementById("mint-button").innerHTML = "Minting..."
                  document.getElementById("mint-button").removeAttribute("onclick")
                  const receipt = await tx.wait();
                  document.getElementById("mint-button").innerHTML = "Success!"
                  document.getElementById("mint-again").style.display=null;
                  getStats(connectedAddr);
              }
      }
    }



const day = () => {
  document.getElementById("module").classList.remove("mint-page-night")
  document.getElementById("module").classList.add("mint-page-day")
}

const war = () => {
  document.getElementById("module").classList.add("mint-page-night")
  document.getElementById("module").classList.remove("mint-page-day") 
}


const goMint = () => {
  document.getElementById("mint-button").innerHTML = "Mint " + mintvalue + " (" + COST_GOLD_ETH*mintvalue +  " ETH)";
  document.getElementById("mint-button").style.display=null;
  document.getElementById("mint-button-credit-card").style.display=null;

}

const goMintReserved = () => {
  document.getElementById("mint-button-reserved").innerHTML = "Mint " + mintvalueReserved + " (FREE)";
  document.getElementById("mint-button-reserved").style.display=null;
}

const goMintPass = () => {
  document.getElementById("rota-public-mint").style.display="none";
  document.getElementById("rota-reserved-mint").style.display=null;
}

function set(x){
  setMintValue(x);
  document.getElementById("select").classList.remove("disabled");
}




  return (
  <main className="page-wrapper">

<header className="header navbar navbar-expand-lg bg-secondary shadow-sm shadow-dark-mode-none">
      <div className="container px-3">
        <a href="https://atsnft.io/" className="navbar-brand pe-3">
          <img src="ape.png" width={47} alt="Logo" />
        </a>
        <div id="navbarNav" className="offcanvas offcanvas-end">
          <div className="offcanvas-header border-bottom">
            <h5 className="offcanvas-title">Menu</h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
                <a href="https://records.atsnft.io/" className="nav-link text-nowrap">Records</a>
              </li>
              <li className="nav-item">
              <a href="https://mint.atsnft.io/" className="nav-link text-nowrap active" style={{color:"#e9ca7a"}}>Looking Glass</a>
              </li>
              <li className="nav-item">
              <a href="https://marketplace.atsnft.io/" target="_blank" className="nav-link text-nowrap">Marketplace</a>
              </li>
              <li className="nav-item">
              <a href="https://warbonds.atsnft.io/" className="nav-link text-nowrap">War Bonds</a>
              </li>
              <li className="nav-item">
              <a href="https://war.atsnft.io/" className="nav-link text-nowrap">War</a>
              </li>
              <li className="nav-item">
              <a href="https://records.atsnft.io/tickets" className="nav-link text-nowrap">Tickets</a>
              </li>
              <a href="https://twitter.com/ATSNFT" target="_blank" className="btn btn-icon btn-secondary btn-twitter d-none rounded-circle mx-1 d-lg-inline-flex"><i className="bx bxl-twitter"></i></a>
             <a href="https://discord.com/invite/ATSNFT" target="_blank" className="btn btn-icon btn-secondary btn-discord d-none rounded-circle mx-1 d-lg-inline-flex"><i className="bx bxl-discord"></i></a>
             
            </ul>
          </div>
          <div className="offcanvas-header border-top">
          </div>      
        </div>
        <div className="form-check form-switch mode-switch pe-lg-1 ms-auto me-4"  >
        {/* <button className="btn btn-daytime" type="button" onClick={day} >Day</button>
        <button  className="btn btn-nighttime" type="button" onClick={war} >War</button> */}
        </div>
        <button type="button" className="navbar-toggler" data-bs-toggle="offcanvas" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
      </div>
    </header>

    <section id="module" className="mint-page-mutation" >
      <div  id="connect-wallet" className="row justify-content-center text-center pb-4 mb-2 mint-module">
            <div className="col-xl-12 col-lg-9 col-md-10 py-4">
              <br></br>
              <a className="btn btn-connect about-us"  rel="noopener">
              <WagmiConfig client={client}>
      <ConnectKitProvider 
           theme="midnight"
      >
        <ConnectKitButton />
        <Connected />
      </ConnectKitProvider>
    </WagmiConfig>
      </a>
           <section  id="mutation-calcs" style={{display:"none"}}>
              <div className="mint-text-large">You own <b><span id="amount-of-reserve" style={{color:"#64e2ff"}}><span className="text-loading">...</span></span></b> Genesis Apes</div>
              <div className="mint-text-large">You own <b><span id="amount-of-reserve-glass" style={{color:"#64e2ff"}}><span className="text-loading">...</span></span></b> Looking Glass Tokens</div>
              <div className="mint-text-large">You mutated <b><span id="amount-of-mutations" style={{color:"#64e2ff"}}><span className="text-loading">...</span></span></b> Genesis Apes</div>
              <div className="mint-text-large">You can mutate <b><span id="amount-of-mutations-left" style={{color:"#e9ca7a"}}><span className="text-loading">...</span></span></b> Genesis Apes</div>
            </section>
            <br></br>
            <button style={{margin:"5px",display:"none"}}  id="mint-button" className="btn btn-primary btn-connect about-us" onClick={e => navigate(`/mutation?address=${addr}`)} >Start Mutation</button>
            </div> 

            <div className="col-xl-8 col-lg-9 col-md-10">
            <a href="https://etherscan.io/address/0xdfb29501b42f63a947ddc5249f185d6bcbe6986f" target="_blank" className="btn btn-icon btn-secondary btn-facebook rounded-circle mx-1 d-lg-inline-flex"><img style={{height:"20px"}} src="etherscan.png"></img></a>
            <a href="https://opensea.io/collection/rotanft" target="_blank" className="btn btn-icon btn-secondary btn-twitter rounded-circle mx-1 d-lg-inline-flex"><img style={{height:"25px"}} src="opensea.png"></img></a>
            <a href="https://atsnft.io/terms-of-sale/" target="_blank" className="btn btn-secondary btn-google mx-1 d-lg-inline-flex">Terms of Sale</a>
            </div>       
          </div>

</section>
</main>

  );
}

export default App;